var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"innerBox"},[_c('h2',{staticClass:"mb-4"},[_vm._v("Supply Apply")]),_c('vue-universal-table',{attrs:{"api_url":"/api/v1/masterdata/supply-apply","indexing":true,"fields":_vm.vue_universal_table.fields}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }